import { STAGE_CONFIG } from '@/config';

// External service URLs surfaced from the admin UI. The ServiceNow instance is
// derived per stage so dev/test never deep-link into the production instance
// (dev -> mitdev, test -> mittest, prod -> mit). Still not SSM-backed; the move
// to SSM-sourced config is tracked in docs/architecture/06-account-model.md §11.

// ServiceNow instance host for the current stage. Mirrors the stage handling in
// common/composables/url/url.ts: only 'prod' is production, and anything that
// is not an explicit 'prod'/'test' (including 'dev', 'development', local, or an
// unknown value) falls back to the dev instance so we never point at prod by
// accident.

export const PARLEY_DOCS_URL = 'https://parley-docs.mit.edu/';

// Docs site host for the current stage: the Docusaurus site is deployed once
// per stage, prod on the bare host and the others on a -stage suffix. Stage
// handling mirrors serviceNowHost() and url.ts: only 'prod' is production, and
// anything that is not an explicit 'prod'/'test' (including 'dev',
// 'development', local, or an unknown value) falls back to the dev host so a
// non-prod build never deep-links into the published docs.
function docsHost(): string {
  const stage = STAGE_CONFIG.stage;
  if (stage === 'prod') return 'parley-docs.mit.edu';
  if (stage === 'test') return 'parley-docs-test.mit.edu';
  return 'parley-docs-dev.mit.edu';
}

/**
 * Absolute URL to a page on the stage-appropriate docs site. `path` is the
 * site-relative route, with or without its leading slash.
 */
export function getParleyDocsUrl(path = ''): string {
  const suffix = path && !path.startsWith('/') ? `/${path}` : path;
  return `https://${docsHost()}${suffix}`;
}

// Knowledge base / RAG landing page in the docs, per stage.
export function getRagDocsUrl(): string {
  return getParleyDocsUrl('/rag/overview');
}

function serviceNowHost(): string {
  const stage = STAGE_CONFIG.stage;
  if (stage === 'prod') return 'mit.service-now.com';
  if (stage === 'test') return 'mittest.service-now.com';
  return 'mitdev.service-now.com';
}

// TODO(account-model): replace host derivation with SSM-sourced config.
// Deep-links to the "Parley request account" Service Portal form on the
// stage-appropriate ServiceNow instance.
export function getRequestAccountServiceNowUrl(): string {
  return `https://${serviceNowHost()}/?id=service_form&sys_id=parley_request_account`;
}
